import { Link, NavLink } from "react-router-dom";
import { Menu, UserRoundCog } from "lucide-react";
import { Logo } from "./Logo";

export function PublicHeader() {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white" data-testid="public-header">
      <div className="vtc-container flex min-h-20 items-center justify-between gap-2 py-3 sm:min-h-24 sm:gap-4 sm:py-4">
        <Link to="/" className="min-w-0 shrink focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2" data-testid="header-home-link">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-6 text-sm font-bold text-slate-700 md:flex" data-testid="desktop-navigation">
          <NavLink to="/" className="transition-colors duration-200 hover:text-blue-900" data-testid="nav-latest-link">சமீபத்தியவை</NavLink>
          <a href="#trending" className="transition-colors duration-200 hover:text-blue-900" data-testid="nav-trending-link">பிரபலமானவை</a>
          <a href="#newsletter" className="transition-colors duration-200 hover:text-blue-900" data-testid="nav-newsletter-link">செய்திமடல்</a>
        </nav>
        <div className="flex shrink-0 items-center gap-2">
          <Link to="/admin" className="inline-flex h-10 w-10 items-center justify-center border border-blue-900 text-sm font-black text-blue-950 transition-colors duration-200 hover:bg-blue-900 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2 sm:w-auto sm:px-4 sm:py-2" data-testid="admin-login-header-link">
            <UserRoundCog className="h-4 w-4" aria-hidden="true" />
            <span className="hidden sm:inline">Admin</span>
          </Link>
          <button className="inline-flex h-10 w-10 items-center justify-center border border-slate-300 text-slate-700 md:hidden" data-testid="mobile-menu-button" aria-label="Open menu">
            <Menu className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </header>
  );
}